<template>
  <l-layout :layout="['xs12']">
    <reservation-form :type="type" :authority="auth" :reservation="newReservation"></reservation-form>
  </l-layout>
</template>

<script>
import ReservationForm from '../Common/reservationForm'
import {ReservationGroup, Reservation} from '../../../object'

export default {
  name: 'NewAPersonalReservation',
  components: {ReservationForm},
  data: () => ({
    newReservation: new ReservationGroup(),
    type: Reservation.PERSONAL,
  }),
  computed: {
    auth () {
      return this.$store.state.reservation.personalAuth
    }
  }
}
</script>

<style scoped>

</style>
